/** Shared layout/style tokens for Ella Agent Hub forms. */
export const FORM_MAX_WIDTH = 720;

/** Max content width for Agent Hub header + dashboard (aligns live toggle with metrics body). */
export const AGENT_HUB_CONTENT_MAX_WIDTH = 1100;

/**
 * Radio styling used across Agent Hub. Checked stays black when editable; both
 * unchecked and checked use the disabled grey when `disabled` (e.g. merchant read).
 */
export const radioSx = {
  color: '#000',
  p: 0,
  '&.Mui-checked': { color: '#000' },
  '&.Mui-disabled': { color: 'action.disabled' },
  // Checked+disabled must beat `&.Mui-checked` or radios stay black in read-only
  '&.Mui-checked.Mui-disabled': { color: 'action.disabled' },
};

export const selectionBoxSx = (isSelected: boolean, readOnly: boolean) => {
  if (readOnly) {
    return {
      boxSizing: 'border-box' as const,
      display: 'flex',
      flexDirection: 'column' as const,
      alignItems: 'center',
      justifyContent: 'center',
      gap: 0.25,
      p: '8px',
      border: '1px solid',
      borderColor: isSelected ? '#9E9E9E' : '#BDBDBD',
      borderRadius: '4px',
      backgroundColor: isSelected ? '#9E9E9E' : '#FFFFFF',
      color: isSelected ? '#FFFFFF' : '#9E9E9E',
      fontFamily: 'Poppins, sans-serif',
      cursor: 'default',
      textAlign: 'center' as const,
    };
  }

  return {
    boxSizing: 'border-box' as const,
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    justifyContent: 'center',
    gap: 0.25,
    p: '8px',
    border: '1px solid',
    borderColor: isSelected ? '#000000' : '#757575',
    borderRadius: '4px',
    backgroundColor: isSelected ? '#000000' : '#FFFFFF',
    color: isSelected ? '#FFFFFF' : '#000000',
    fontFamily: 'Poppins, sans-serif',
    cursor: 'pointer',
    textAlign: 'center' as const,
    '&:hover': {
      borderColor: '#000000',
    },
  };
};

export const exampleBoxSx = (backgroundColor = '#FFFFFF') => ({
  maxWidth: FORM_MAX_WIDTH,
  backgroundColor,
  border: '1px solid',
  borderColor: '#E0E0E0',
  borderRadius: '4px',
  px: 2,
  py: 1.5,
});
